


























import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'
import PullAndScroll from 'components/PullAndScroll.vue'
import ContentFolder from 'components/presenter/item/folder/Content.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    PullAndScroll,
    ContentFolder
  }
})
export default class PagePresenterIndex extends Vue {

  created () {
    store.presenterInit({} as Item)
  }

  async refresh (done: () => void) {
    const subpage = (this.$refs.subpage as PullAndScroll)
    await subpage.refresh(done)
  }

  async load (index: number, done: (stop?: boolean) => void) {
    const subpage = (this.$refs.subpage as PullAndScroll)
    await subpage.load(index, done)
  }
}
